import { isLocaleFrench, isLocaleSpanish } from '@lib/i18n';
import { IBenefitsMedia, IBenefitsScreenSizes } from './benefits-refactor.interface';
import { isMobileView, isTabletView } from '@lib/screen-sizes';

export function getResponsiveMedia(media: IBenefitsMedia): string {
  if (!media) return '';

  const localizedMedia = getLocalizedMedia(media);
  return getMediaByScreenSize(localizedMedia);
}

export function getLocalizedMedia(media: IBenefitsMedia): IBenefitsScreenSizes {
  if (isLocaleFrench()) return media?.fr;
  else if (isLocaleSpanish()) return media?.es;
  else return media.en;
}

function getMediaByScreenSize(media: IBenefitsScreenSizes): string {
  if (isMobileView()) return media?.sm;
  if (isTabletView()) return media?.md;
  return media.lg;
}

// Returns a formatted string for a list of items with proper conjunctions - used to format Rebates Text to show list of partners
export function formatReadableList(items: string[]): string {
  if (!items.length) return '';

  if (items.length === 1) return items[0];
  if (items.length === 2) {
    return $localize`${items[0]} and ${items[1]}`;
  }
  const lastItem = items.pop();
  return $localize`${items.join(', ')} and ${lastItem}`;
}

// Function to build event names for Pendo Tracking
export const buildEvent = (section: string, label: string = '') =>
  label ? `Benefits - ${section} - ${label} - Click` : `Benefits - ${section} - Click`;
